<template>
    <div class="DriverForm">
        <DashboardEditSection title="Account">
            <FormInput
                v-model="$v.email.$model"
                label="Email"
                :errors="$v.email.$error ? [
                    !$v.email.required && 'Email or username is required',
                ] : null"
            />
            <FormInput
                v-model="$v.username.$model"
                label="Username"
                :errors="$v.username.$error ? [
                    !$v.username.required && 'Username or email is required',
                    !$v.username.minLength && 'Username has to be at least 3 characters long',
                    !$v.username.username && 'Usernames must only contain alphanumeric characters. Hyphens, periods and underscores are allowed',
                ] : null"
            />
            <div class="inlineForm">
                <FormPasswordInput value="••••••" type="password" label="Password" disabled/>
                <Button class="link" @click="handleChangePassword">Change Password</Button>
            </div>
        </DashboardEditSection>

        <DashboardEditSection title="Information">
            <Row>
                <Column :md="6">
                    <FormInput
                        v-model="$v.firstName.$model"
                        label="First Name"
                        :errors="$v.firstName.$error ? [
                            !$v.firstName.required && 'First name is required',
                        ] : null"
                    />
                </Column>
                <Column :md="6">
                    <FormInput
                        v-model="$v.lastName.$model"
                        label="Last Name"
                        :errors="$v.lastName.$error ? [
                            !$v.lastName.required && 'Last name is required',
                        ] : null"
                    />
                </Column>
            </Row>
            <FormInput v-model="phone" label="Phone"/>

            <Row>
                <Column :md="6">
                    <FormInput v-model="di_employeeCode" label="Employee Code"/>
                </Column>
                <Column :md="6">
                    <FormDateInput v-model="di_hiredAt" label="Hire Date"/>
                </Column>
            </Row>

            <Row>
                <Column :md="6">
                    <FormSelect v-model="di_type" label="Employee Type">
                        <option value="employee">Employee</option>
                        <option value="subcontractor">Subcontractor</option>
                    </FormSelect>
                </Column>
                <Column :md="6">
                    <FormNumber v-model="di_rate" label="Pay Rate" :min="0"/>
                </Column>
            </Row>

            <Row>
                <Column :md="6">
                    <FormInput v-model="di_driverLicense" label="Driver License"/>
                </Column>
                <Column :md="6">
                    <FormDateInput v-model="di_medicalExpireAt" label="Medical Examination Expiration"/>
                </Column>
            </Row>
        </DashboardEditSection>

        <DashboardEditSection title="Address">
            <AddressForm
                :address.sync="address"
                :city.sync="city"
                :state.sync="state"
                :zip.sync="zip"
            />
        </DashboardEditSection>
    </div>
</template>

<script>
import DashboardEditSection from '@/components/DashboardEditSection';
import AddressForm from '@/components/form/AddressForm';
import { required, requiredUnless, minLength, helpers } from 'vuelidate/lib/validators';
import DriverChangePasswordModal from './DriverChangePasswordModal';

export default {
    name: 'DriverForm',

    components: {
        DashboardEditSection,
        AddressForm,
    },

    props: {
        id: { type: Number, required: true },
    },

    syncProps: [
        'email',
        'username',
        'firstName',
        'lastName',
        'phone',
        'address',
        'city',
        'state',
        'zip',
        'di_type',
        'di_employeeCode',
        'di_driverLicense',
        'di_rate',
        'di_hiredAt',
        'di_medicalExpireAt',
    ],

    data: () => ({
        passwordConfirm: '',
    }),

    validations: {
        email: { required: requiredUnless('username') },
        username: {
            required: requiredUnless('email'),
            minLength: minLength(4),
            username: helpers.regex('username', /^\w+[\w.-]+\w+$/),
        },
        firstName: { required },
        lastName: { required },
    },

    methods: {
        validate() {
            this.$v.$touch();
            return !this.$v.$invalid;
        },

        handleChangePassword() {
            this.$modal.show(DriverChangePasswordModal,
                { id: this.id },
                { height: 'auto', scrollable: true },
            );
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';
.DriverForm {
    .inlineForm {
        position: relative;

        .Button {
            position: absolute;
            margin-top: 34px;
            margin-right: 3px;
            padding: 0 15px;
            top: 0;
            right: 0;
            height: 30px;
            line-height: 1;
            border: none;
            background-color: $bg-color-3;
        }
    }

    .saveBtn {
        display: block;
        margin-left: auto;
    }
}
</style>
